import { createContext, useContext, useState } from 'react';

const ModalContext = createContext();

export function ModalProvider({ children }) {
    const [modal, setModal] = useState(null);

    // alert 대체
    const showAlert = (message, type = 'info') => {
        return new Promise(resolve => {
            setModal({
                type: 'alert',
                messageType: type,
                message,
                onConfirm: () => { setModal(null); resolve(); }
            });
        });
    };

    // confirm 대체
    const showConfirm = (message) => {
        return new Promise(resolve => {
            setModal({
                type: 'confirm',
                message,
                onConfirm: () => { setModal(null); resolve(true); },
                onCancel: () => { setModal(null); resolve(false); }
            });
        });
    };

    return (
        <ModalContext.Provider value={{ showAlert, showConfirm }}>
            {children}
            {modal && <Modal modal={modal} />}
        </ModalContext.Provider>
    );
}

function Modal({ modal }) {
    const iconMap = {
        success: { icon: '✓', color: '#111' },
        error: { icon: '✕', color: '#e74c3c' },
        info: { icon: 'i', color: '#111' },
        warning: { icon: '!', color: '#f39c12' },
    };

    const { icon, color } = iconMap[modal.messageType] || iconMap.info;

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            background: 'rgba(0,0,0,0.4)', zIndex: 9999,
            display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
            <div style={{
                background: 'white', borderRadius: '8px', padding: '40px 36px',
                maxWidth: '400px', width: '90%', textAlign: 'center',
                boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
            }}>
                {modal.type === 'alert' && (
                    <div style={{
                        width: '52px', height: '52px', borderRadius: '50%',
                        background: color, color: 'white',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: '22px', fontWeight: '700',
                        margin: '0 auto 20px'
                    }}>
                        {icon}
                    </div>
                )}
                <p style={{ fontSize: '15px', color: '#222', lineHeight: '1.6', marginBottom: '28px', whiteSpace: 'pre-line' }}>
                    {modal.message}
                </p>
                {modal.type === 'alert' && (
                    <button onClick={modal.onConfirm} style={{
                        width: '100%', padding: '13px', background: '#111',
                        color: 'white', border: 'none', fontSize: '14px',
                        letterSpacing: '1px', cursor: 'pointer', borderRadius: '4px'
                    }}>
                        확인
                    </button>
                )}
                {modal.type === 'confirm' && (
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <button onClick={modal.onCancel} style={{
                            flex: 1, padding: '13px', background: 'white',
                            color: '#111', border: '1px solid #111', fontSize: '14px',
                            letterSpacing: '1px', cursor: 'pointer', borderRadius: '4px'
                        }}>
                            취소
                        </button>
                        <button onClick={modal.onConfirm} style={{
                            flex: 1, padding: '13px', background: '#111',
                            color: 'white', border: 'none', fontSize: '14px',
                            letterSpacing: '1px', cursor: 'pointer', borderRadius: '4px'
                        }}>
                            확인
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export const useModal = () => useContext(ModalContext);